module.exports = __webpack_public_path__ + "static/media/nak-muay-4.d6289b11.svg";